import { createContext } from 'react';
import type { 
  Invoice, 
  CreateInvoiceInput, 
  UpdateInvoiceInput 
} from '../types';

export interface InvoicesContextType {
  invoices: Invoice[];
  loading: boolean;
  error: string | null;
  addInvoice: (invoice: CreateInvoiceInput) => Promise<Invoice>;
  updateInvoice: (invoiceId: string, invoiceData: UpdateInvoiceInput) => Promise<Invoice>;
  updateInvoiceStatus: (invoiceId: string, status: Invoice['status']) => Promise<Invoice>;
  approveInvoice: (invoiceId: string) => Promise<Invoice>;
  deleteInvoice: (invoiceId: string) => Promise<void>;
  refreshInvoices: () => Promise<void>;
  getInvoiceById: (invoiceId: string) => Invoice | undefined;
}

export const InvoicesContextObject = createContext<InvoicesContextType | undefined>(undefined);